export default __webpack_public_path__ + "static/media/globe.d3ffaa90.png";